import { BirthdaySchema } from "@book-club/shared";
import { z } from "zod";

export const addMemberFormSchema = z.object({
    birthday: BirthdaySchema.optional(),
    displayName: z.string().min(1, "Display name is required").max(200, "Display name is too long"),
    grantAccess: z.boolean(),
    phoneNumber: z
        .string()
        .min(1, "Phone number is required")
        .refine((val) => /^[\d\s+()-]{10,20}$/.test(val.trim()), "Enter a valid phone number"),
});

export type AddMemberFormData = z.infer<typeof addMemberFormSchema>;
